<div class="ks">
  <ion-card *ngIf="beadas" class="osap" [class.kesz]="beadas.beadva" [class.surgos]="!beadas.beadva && (beadas.allapot === 'esedekes' || beadas.allapot === 'lejart')">
    <ion-card-header>
      <ion-card-title>{{ beadas.ev }}. évi október 1-jei statisztika – beküldési határidő: {{ beadas.hatarido | date:'yyyy.MM.dd.' }}</ion-card-title>
      <ion-card-subtitle>
        „… az október 1-jei állapot szerinti közérdekű adatairól minden év október 15-ig – a KIR-en keresztül … az OSAP keretében adatokat közöl.”
        ({{ beadas.jogalap }}). A lezárt statisztika módosítása {{ beadas.modositas_kerheto.tol | date:'MM.dd.' }} és {{ beadas.modositas_kerheto.ig | date:'MM.dd.' }} között egy alkalommal kérhető.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="ks-sor">
        <ion-badge [color]="beadas.beadva ? (beadas.allapot === 'kesve_beadva' ? 'warning' : 'success') : (beadas.allapot === 'lejart' ? 'danger' : (beadas.allapot === 'esedekes' ? 'warning' : 'medium'))">
          {{ beadasAllapotNev(beadas.allapot) }}
        </ion-badge>
        <span *ngIf="beadas.beadva" class="halvany">Beadás napja: {{ beadas.beadas_datuma | date:'yyyy.MM.dd.' }} · jelölte: {{ beadas.beadta || '–' }} ({{ beadas.beadva_ido }}){{ beadas.megjegyzes ? ' · ' + beadas.megjegyzes : '' }}</span>
      </div>
      <div class="ks-sor" *ngIf="!beadas.beadva">
        <ion-input type="date" label="A beküldés napja" labelPlacement="stacked" fill="outline" [(ngModel)]="beadasDatum"></ion-input>
        <ion-input label="Megjegyzés (nem kötelező)" labelPlacement="stacked" fill="outline" [(ngModel)]="beadasMegj" maxlength="500"></ion-input>
        <ion-button (click)="beadasJelol(true)" [disabled]="beadasFut"><ion-icon slot="start" name="checkmark-done-outline"></ion-icon>Beadtam</ion-button>
      </div>
      <div class="ks-sor" *ngIf="beadas.beadva">
        <ion-button fill="clear" size="small" color="medium" (click)="beadasJelol(false)" [disabled]="beadasFut">Jelölés visszavonása</ion-button>
      </div>
      <p class="halvany" *ngIf="!beadas.beadva">Amíg nincs „Beadtam” jelölés, október 1. és 15. között naponta rendszerüzenet megy az adminisztrátoroknak. A Sulinform a KIR-be nem küld adatot – a beküldés a KIR-STAT felületén történik.</p>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>KIR-STAT kitöltő segédlet (október 1.)</ion-card-title>
      <ion-card-subtitle>
        Az OSAP 1410 adatszolgáltatás tábláinak értékei a rendszer adataiból, a KIR adatlapcsomagjához hasonló
        PDF-ben (adatlap, táblakód, sor, oszlop) – a webes KIR-STAT kitöltéséhez. Csak az itt számolható táblák
        szerepelnek; az eszközöket, a helyiségeket, a pedagógusadatokat stb. a KIR-ben kell megadni.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="ks-sor">
        <ion-input type="date" label="Vonatkozási nap" labelPlacement="stacked" fill="outline" [(ngModel)]="datum" (ionChange)="helyekBetolt(); beadasBetolt()"></ion-input>
        <ion-button (click)="elonezet()" [disabled]="betolt"><ion-icon slot="start" name="eye-outline"></ion-icon>{{ betolt ? 'Számolás…' : 'Előnézet' }}</ion-button>
        <ion-button fill="outline" (click)="pdf()" [disabled]="pdfFut"><ion-icon slot="start" name="document-outline"></ion-icon>{{ pdfFut ? 'PDF készül…' : 'PDF letöltése' }}</ion-button>
      </div>
      <ion-note color="danger" *ngIf="hiba">{{ hiba }}</ion-note>

      <h3>Feladatellátási helyek</h3>
      <p class="halvany">A KIR feladatellátási helyenként kér adatlapot. A kód a KIR-beli sorszám (001 a székhely). A település a „más településről bejáró” számolásához kell.</p>
      <table class="ks-tabla">
        <tr><th>Kód</th><th>Név</th><th>Ir.sz.</th><th>Település</th><th>Cím</th><th></th></tr>
        <tr *ngFor="let h of helyek; let i = index">
          <td><input class="rovid" [(ngModel)]="h.kod" maxlength="3"></td>
          <td><input [(ngModel)]="h.nev"></td>
          <td><input class="rovid" [(ngModel)]="h.irsz" maxlength="4"></td>
          <td><input [(ngModel)]="h.telepules"></td>
          <td><input [(ngModel)]="h.cim"></td>
          <td><ion-button fill="clear" size="small" color="danger" *ngIf="helyek.length > 1" (click)="helyTorol(i)"><ion-icon name="trash-outline"></ion-icon></ion-button></td>
        </tr>
      </table>
      <ion-button fill="clear" size="small" (click)="ujHely()"><ion-icon slot="start" name="add-outline"></ion-icon>Új feladatellátási hely (telephely)</ion-button>

      <h3 *ngIf="osztalyok.length">Melyik osztály hol tanul?</h3>
      <table class="ks-tabla" *ngIf="osztalyok.length">
        <tr><th>Osztály</th><th>Évfolyam</th><th>Létszám</th><th>Feladatellátási hely</th></tr>
        <tr *ngFor="let o of osztalyok">
          <td>{{ o.nev }}</td><td>{{ o.evfolyam }}.</td><td>{{ o.db }}</td>
          <td><select [(ngModel)]="o.fh"><option *ngFor="let h of helyek" [value]="h.kod">{{ h.kod }} – {{ h.nev || '(név nélkül)' }}</option></select></td>
        </tr>
      </table>
      <div class="ks-sor"><ion-button size="small" (click)="helyekMent()" [disabled]="ment">{{ ment ? 'Mentés…' : 'Helyek mentése' }}</ion-button></div>
    </ion-card-content>
  </ion-card>

  <ion-card *ngIf="segedlet">
    <ion-card-header>
      <ion-card-title>Előnézet – {{ segedlet.tanulo_db }} tanuló, vonatkozási nap: {{ segedlet.datum }}</ion-card-title>
      <ion-card-subtitle *ngIf="segedlet.figyelmeztetes" class="figyelm">{{ segedlet.figyelmeztetes }}</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div *ngFor="let a of segedlet.adatlapok" class="ks-lap">
        <h3>{{ a.lap }} · {{ a.sorszam }}. adatlap — {{ a.cim }} <small>({{ kitoltott(a) }} kitöltött tábla)</small></h3>
        <div *ngFor="let t of a.tablak" class="ks-t" [class.ures]="t.allapot !== 'Kitöltve'">
          <div class="ks-tcim"><b>{{ t.kod }}</b> {{ t.cim }} <span class="all">{{ t.allapot }}</span></div>
          <div class="gorgo" *ngIf="t.allapot === 'Kitöltve'">
            <table class="ks-tabla ertekek">
              <tr><th class="cimke"></th><th>sor</th><th *ngFor="let o of t.oszlopok" [title]="o.cim">{{ o.cim }}<div class="on">{{ o.n }}</div></th></tr>
              <tr *ngFor="let s of t.sorok"><td class="cimke">{{ s.cim }}</td><td class="ss">{{ s.n }}</td>
                <td *ngFor="let o of t.oszlopok" [class.van]="ertek(t, s.n, o.n) !== ''">{{ ertek(t, s.n, o.n) }}</td></tr>
            </table>
          </div>
          <div class="forras">Forrás: {{ t.forras }}</div>
        </div>
      </div>
    </ion-card-content>
  </ion-card>
</div>
